import { router } from 'expo-router';
import { useState } from 'react';
import Animated, { FadeIn, LinearTransition } from 'react-native-reanimated';
import { isWeb, Notice, View } from 'smoothie';

import PendingInvitations from '../../../banking/components/joint-account-holder/PendingInvitations';
import { useGetPendingJointInvites } from '../../../banking/hooks/useGetJointInvites';
import { KYCVerificationStatus } from '../../../banking/types/BankAccount';
import { useAuthedUser } from '../../../common/providers/AuthedUserProvider';
import { SIDEBAR_CONTENT_MAX_WIDTH } from '../../../common/utils/homeUtils';

const PendingJointInvitationsNotice = ({
    isFullWidth = false,
}: {
    isFullWidth?: boolean;
}) => {
    const user = useAuthedUser();
    const { pendingJointInvitations } = useGetPendingJointInvites();
    const show =
        pendingJointInvitations != null && pendingJointInvitations.length > 0;

    const [showPendingInvitesSheet, setShowPendingInvitesSheet] =
        useState(false);

    return show ? (
        <Animated.View
            style={{ width: '100%' }}
            {...(isWeb
                ? { entering: FadeIn.duration(500) }
                : { layout: LinearTransition.duration(500) })}
        >
            <View
                width="100%"
                maxWidth={isFullWidth ? '100%' : SIDEBAR_CONTENT_MAX_WIDTH}
                alignSelf="center"
            >
                <Notice
                    variant="neutral"
                    title="Fruitful Cash Account invitation"
                    description="You've been invited to be a joint account owner on a Fruitful Cash Account!"
                    action={{
                        text: 'View invitation',
                        onPress: () => {
                            user.syncteraKycStatus !==
                                KYCVerificationStatus.ACCEPTED &&
                            user.syncteraKycStatus != null
                                ? router.push('/home/banking')
                                : setShowPendingInvitesSheet(true);
                        },
                    }}
                />
            </View>
            <PendingInvitations
                isOpen={showPendingInvitesSheet}
                onClose={() => {
                    setShowPendingInvitesSheet(false);
                }}
                user={user}
            />
        </Animated.View>
    ) : null;
};

export default PendingJointInvitationsNotice;
